import React, { memo } from 'react';

import { useTranslation } from 'react-i18next';
import { InputNumber } from '@bringg/react-components';

import styles from './delivery-window-fee.module.scss';

const MAX_FEE = 1000;
const MIN_FEE = 0;

interface Props {
	fee: number;
	onFeeChange: (fee: number | null) => void;
	titleClassName?: string;
}

const DeliveryWindowFee = ({ fee, onFeeChange, titleClassName }: Props) => {
	const { t } = useTranslation();

	// Create a wrapper function to handle the type conversion
	const handleChange = (value: number | string | null | undefined) => {
		// Convert the value to number or null, handling empty strings, avoiding TS errors
		onFeeChange(value ? Number(value) : null);
	};

	return (
		<>
			<div className={titleClassName}>{t('PLANNED_DELIVERY_WINDOWS_MODAL_CONDITIONS.FEE')}</div>
			<InputNumber
				data-test-id="delivery-window-fee"
				className={styles.deliveryWindowFeeInput}
				value={fee}
				type="number"
				onChange={handleChange}
				max={MAX_FEE}
				min={MIN_FEE}
				precision={2}
			/>
		</>
	);
};

export default memo(DeliveryWindowFee);
